import styles from './ShifterItem.module.css';

const ShifterItem = ({ children }) => {
  return <div className={styles.Root}>{children}</div>;
};

export default ShifterItem;
